<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="chemical_code">{{ $t('iun_chemical_code') }}</label>
                        <InputText
                            id="chemical_code"
                            type="text"
                            v-model="chemical_code"
                            ref="TextBox_1_search"
                            @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                        />
                    </div>
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="chemical_name">{{ $t('iun_chemical_name') }}</label>
                        <InputText
                            id="chemical_name"
                            type="text"
                            v-model="chemical_name"
                            ref="TextBox_2_search"
                            @keyup.left="moveFocus($event, 'TextBox_1_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                        />
                    </div>
                    <div class="p-field p-col">
                        <div class="p-formgrid p-grid p-jc-end p-mt-5">
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                v-if="window.width <= 430"
                                @click="MobileClearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_3_search"
                                @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                            />
                            <Button
                                v-else
                                @click="clearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_3_search"
                                @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                            />
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                @click="searchChemicalInfo()"
                                :label="$t('searchBtn')"
                                class="p-button-info"
                                ref="TextBox_4_search"
                                @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_1_search', 'Input')"
                            />
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="chemicalInfo_table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/5   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? chemicalInfo_table : []"
                :paginator="true"
                scrollHeight="500px"
                :rows="10"
                dataKey="un_id"
                ref="dt"
                :exportFilename="`UN Number-${date}`"
                :rowHover="true"
                :selection.sync="selectedChemicalInfo"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/5 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="chemicalInfoModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedChemicalInfo && selectedChemicalInfo.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedChemicalInfo.length === chemicalInfo_table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedChemicalInfo.some((item) => item.un_id === slotProps.data.un_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <!--Doe : เพิ่มลำดับ 2/5-->
                <div v-if="columns_index == true">
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <!-- <div hidden>{{ dataTable.data.un_id }}</div> -->
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <!--Doe : เพิ่มลำดับ 2/5 จบ-->

                <div v-if="columns_un_code == true">
                    <Column
                        field="un_code"
                        :header="$t('iun_chemical_code')"
                        :sortable="true"
                        :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_un_code == true">
                                {{ dataTable.data.un_code }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_un_name == true">
                    <Column
                        field="un_name"
                        :header="$t('iun_chemical_name')"
                        :sortable="true"
                        :headerStyle="tableColSticky('20em', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_un_name == true">
                                {{ dataTable.data.un_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_un_manage == true">
                    <Column
                        field="un_manage"
                        :header="$t('iun_chemical_manage')"
                        :sortable="true"
                        :headerStyle="tableColSticky('65rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_un_manage == true">
                                <div v-if="dataTable.data.un_manage != '' && dataTable.data.un_manage != 'http://'">
                                    <div style="display: flex; justify-content: flex-start; align-items: center">
                                        <a :href="dataTable.data.un_manage" target="_blank" style="margin-right: 1rem"
                                            ><Button icon="pi pi-globe" class="p-button-secondary"></Button
                                        ></a>
                                        {{ dataTable.data.un_manage }}
                                    </div>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create_ddmmyy"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update_ddmmyy"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <div v-if="columns_un_manage || columns_index || columns_un_code || columns_un_name || columns_date_create || columns_date_update">
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <div
                                class="p-formgrid col_manege"
                                style="display: flex; justify-content: center"
                                v-if="checkNotAdminPermission(dataTable.data.user_organize)"
                            >
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            chemicalInfoModal = true;
                                            editData(dataTable.data.un_id);
                                            temp = dataTable.data.un_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.un_id;
                                            alertDisplay(temp);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                            <div v-else>
                                {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>

        <!-- v-if="loadingCreate" -->
        <!-- Manage permission level modal -->
        <Dialog
            :modal="true"
            :visible.sync="chemicalInfoModal"
            :style="{ width: '700px', overflow: 'auto' }"
            :header="header"
            :closable="loadingCreate ? false : true"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" style="top: 26%" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('iun_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="iun_chemical_code">{{ $t('iun_chemical_code') }} <span class="required-input">*</span></label>
                            <InputText
                                id="iun_chemical_code"
                                type="text"
                                v-model="iun_chemical_code"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_iun_chemical_code && !iun_chemical_code
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_3', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_iun_chemical_code && !iun_chemical_code">{{
                                $t('iun_chemical_code_validate')
                            }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="iun_chemical_name">{{ $t('iun_chemical_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="iun_chemical_name"
                                type="text"
                                v-model="iun_chemical_name"
                                required="true"
                                :class="{
                                    'p-invalid': error_iun_chemical_name && !iun_chemical_name
                                }"
                                ref="TextBox_2"
                                @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_iun_chemical_name && !iun_chemical_name">{{
                                $t('iun_chemical_name_validate')
                            }}</small>
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-10 p-lg-10">
                            <label for="iun_chemical_manage">{{ $t('iun_chemical_manage') }}</label>
                            <InputText
                                id="iun_chemical_manage"
                                type="text"
                                v-model="iun_chemical_manage"
                                ref="TextBox_3"
                                @keyup.left="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_4', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                        </div>
                        <div class="p-field p-col-2 p-mt-5">
                            <a :href="iun_chemical_manage" target="_blank"
                                ><Button
                                    icon="pi pi-globe"
                                    class="p-button-secondary"
                                    style="margin-top: -3.5px"
                                    ref="TextBox_4"
                                    @keyup.left="moveFocus($event, 'TextBox_3', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                                >
                                </Button
                            ></a>
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col-12" style="display: flex; justify-content: flex-end">
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    :disabled="loadingCreate ? true : false"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_5"
                    @keyup.left="moveFocus($event, 'TextBox_4', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_6', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_3', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    :disabled="loadingCreate ? true : false"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_5"
                    @keyup.left="moveFocus($event, 'TextBox_4', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_6', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_3', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    :disabled="loadingCreate ? true : false"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveData()"
                    ref="TextBox_6"
                    @keyup.left="moveFocus($event, 'TextBox_5', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_4', 'Button')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button @click="ClearEditPDF()" class="p-button-clear" :label="'ล้างข้อมูล'" style="margin-right: 1rem" />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-UNnumber',
    components: {
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/5
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            chemical_code: '',
            chemical_name: '',
            selectedChemicalInfo: [],
            chemicalInfo_table: [],
            filters: {},
            temp: null,
            displayConfirmation: false,
            chemicalInfoModal: false,

            iun_chemical_code: '',
            iun_chemical_name: '',
            iun_chemical_manage: 'http://',
            error_iun_chemical_code: false,
            error_iun_chemical_name: false,

            header: this.$i18n.t('iun_modal_title_add'),
            selectedData: '',

            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            loading: false,

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'รหัสสารเคมี',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อสารเคมี',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            date_create_form: '',
            date_update_form: '',

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตาราง UN Number',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 80,
            PDF_FontHeaderVer: 12,
            PDF_FontBodyVer: 9,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 35 },
                un_code: { cellWidth: 60 }
            },

            PDF_minCellWidthHor: 70,
            PDF_FontHeaderHor: 12,
            PDF_FontBodyHor: 9,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 },
                un_code: { cellWidth: 60 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'รหัสสารเคมี', dataKey: 'un_code' },
                { title: 'ชื่อสารเคมี', dataKey: 'un_name' },
                { title: 'วิธีจัดการสารเคมี', dataKey: 'un_manage' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_un_code: true,
            columns_un_name: true,
            columns_un_manage: true,
            columns_road_name: true,
            columns_tambon_name: true,
            columns_amphur_name: true,
            columns_province_name: true,
            columns_event_lat: true,
            columns_event_lon: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index', 'un_code'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index', 'un_code'];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        chemicalInfoModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.iun_chemical_code != '' &&
                    this.iun_chemical_name != ''
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.chemicalInfoModal = false;
                            this.clearData();
                        } else {
                            this.chemicalInfoModal = true;
                        }
                    });
                } else {
                    this.clearData();
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;
                }
            }
        },

        displayConfirmationCloseModal(val) {
            // console.log(val);
            if (val == true) {
                this.chemicalInfoModal = true;
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.chemicalInfo_table = [];
            } else {
                this.chemicalInfo_table = this.cloneTable;
            }
        }

        // check_duplicate(val) {
        //   if (val == "duplicate") {
        //     // this.$toast.add({
        //     //   severity: "error",
        //     //   summary: "เพิ่มข้อมูลสารเคมีไม่สำเร็จ",
        //     //   detail: "มีข้อมูลสารเคมีนี้ในระบบแล้ว",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "error",
        //           title:"เพิ่มข้อมูลสารเคมีไม่สำเร็จ",
        //           text: "มีข้อมูลสารเคมีนี้ในระบบแล้ว",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เพิ่มข้อมูลสำเร็จ",
        //     //   detail: "ข้อมูลสารเคมี",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "success",
        //           title:"เพิ่มข้อมูลสำเร็จ",
        //           text: "ข้อมูลสารเคมี",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   }
        // },
    },
    created() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedChemicalInfo.map((item) => ({
                    un_id: item.un_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/unnumber?user=${userId}`, {
                    body: {
                        topic: 'edit-UN_number_date_multiple',
                        selectedChemicalInfo: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.chemicalInfoModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูล UN Number จำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchChemicalInfo();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedChemicalInfo = [...this.chemicalInfo_table];
            } else {
                this.selectedChemicalInfo = [];
            }
            this.$emit('selectedChemicalInfo', this.selectedChemicalInfo);
            // console.log('selectedChemicalInfo', this.selectedChemicalInfo);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedChemicalInfo.some((item) => item.un_id === row.un_id)) {
                    this.selectedChemicalInfo.push(row);
                }
            } else {
                this.selectedChemicalInfo = this.selectedChemicalInfo.filter((item) => item.un_id !== row.un_id);
            }
            this.$emit('selectedChemicalInfo', this.selectedChemicalInfo);
            // console.log('selectedChemicalInfo', this.selectedChemicalInfo);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_3_search') && !this.isFocused('TextBox_4_search')) {
                    this.searchChemicalInfo();
                }
            } else if (ModalName === 'Modal_Main') {
                if (!this.isFocused('TextBox_4') && !this.isFocused('TextBox_5') && !this.isFocused('TextBox_6')) {
                    this.saveData();
                }
            }
        },
        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(() => {
                if (this.filter != '') {
                    this.chemicalInfo_table = this.cloneTable.filter((item) => {
                        return (
                            (this.columns_un_code ? item.un_code.includes(this.filter) : '') ||
                            (this.columns_un_name ? item.un_name.includes(this.filter) : '') ||
                            (this.columns_un_manage ? item.un_manage.includes(this.filter) : '') ||
                            (this.columns_date_create ? item.date_create_ddmmyy.includes(this.filter) : '') ||
                            (this.columns_date_update ? item.date_update_ddmmyy.includes(this.filter) : '')
                        );
                    });

                    for (let i = 0; i < this.chemicalInfo_table.length; i++) {
                        this.chemicalInfo_table[i]['index'] = i + 1;
                    }
                } else {
                    this.chemicalInfo_table = [...this.cloneTable];
                    for (let i = 0; i < this.chemicalInfo_table.length; i++) {
                        this.chemicalInfo_table[i]['index'] = i + 1;
                    }
                }

                // Restore focus to input element after rendering completes
                this.$nextTick(() => {
                    if (this.searchInputRef) {
                        this.searchInputRef.focus();

                        // Place cursor at the end of the text
                        const length = this.searchInputRef.value.length;
                        this.searchInputRef.setSelectionRange(length, length);
                    }
                });
            }, 300); // 300ms delay
        },
        // Doe ค้นหา  3/6 จบ

        async initialData() {
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/unnumber`, {
                    body: {
                        topic: 'get-table'
                        // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/5
                .then((response) => {
                    this.chemicalInfo_table = response.data.data;

                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6

                    this.formatData(this.chemicalInfo_table);
                    // console.log("this.chemicalInfo_table == id  ",this.chemicalInfo_table)
                });
            // Doe : เพิ่ม ลำดับ 3/5 จบ

            if (this.columns_disabled == true) {
                this.chemicalInfo_table = this.cloneTable;
            } else {
                this.chemicalInfo_table = [];
            }

            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                data[index]['index'] = index + 1;

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.displayConfirmationCloseModal = false;
            this.chemicalInfoModal = false;
            this.clearData();
        },

        async searchChemicalInfo() {
            if (!this.checkToken()) {
                return;
            }

            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            // if (this.chemical_code == "" && this.chemical_name == "") {
            //   await this.axios
            //     .post(`${this.$url_service}/initial/unnumber`, {
            //       body: {
            //         topic: "get-table",
            //         // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
            //       },
            //     })
            //     .then((response) => {
            //       this.chemicalInfo_table = response.data.data;
            //        // Doe ค้นหา  5/6
            //        this.cloneTable = response.data.data
            //       // Doe ค้นหา  5/6
            //       // Doe : เพิ่ม ลำดับ 4/5
            //       for (let i = 0; i < this.chemicalInfo_table.length; i++) {
            //       this.chemicalInfo_table[i]["index"] =i+1;
            //     }
            //     // Doe : เพิ่ม ลำดับ 4/5
            //     this.search()
            //     });
            // } else {
            await this.axios
                .post(`${this.$url_service}/initial/unnumber`, {
                    body: {
                        topic: 'search-table',
                        code: this.chemical_code,
                        name: this.chemical_name
                        // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
                    }
                })
                .then((response) => {
                    // Doe : เพิ่ม ลำดับ 5/5
                    this.chemicalInfo_table = response.data.data;
                    // Doe ค้นหา  5/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  5/6

                    // for (let i = 0; i < this.chemicalInfo_table.length; i++) {
                    //   this.chemicalInfo_table[i]["index"] =i+1;
                    // }

                    this.formatData(this.chemicalInfo_table);

                    // Doe : เพิ่ม ลำดับ 5/5
                    // this.search()
                    this.setSearchText_Footer();
                });
            // }

            if (this.columns_disabled == true) {
                this.chemicalInfo_table = this.cloneTable;
            } else {
                this.chemicalInfo_table = [];
            }

            this.search();
            this.loading = false;
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (this.chemical_code !== '' || this.chemical_name !== '') {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'รหัสสารเคมี' && this.chemical_code !== '') {
                        element.textShow = this.chemical_code;
                    }
                    if (element.DataName === 'ชื่อสารเคมี' && this.chemical_name !== '') {
                        element.textShow = this.chemical_name;
                    }
                }
                this.text_Footer = true;
            }
        },
        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            const userId = this.getUsername();

            // console.log('this.checkToken() = ', this.checkToken());

            this.displayConfirmation = false;
            await this.axios
                .post(`${this.$url_service}/initial/unnumber?user=${userId}`, {
                    body: {
                        topic: 'delete-un',
                        id: this.temp
                    }
                })
                .then(() =>
                    // this.initialData()
                    this.searchChemicalInfo()
                );
            // this.$toast.add({
            //   severity: "success",
            //   summary: "ลบข้อมูลสำเร็จ",
            //   detail: "ข้อมูลสารเคมี",
            //   life: 3000,
            // });
            this.$fire({
                type: 'success',
                title: 'ลบข้อมูลสำเร็จ',
                text: 'ข้อมูลสารเคมี',
                timer: 3000,
                confirmButtonColor: '#28B463'
            });
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            if (this.iun_chemical_code == '' || this.iun_chemical_name == '') {
                if (this.iun_chemical_code == '') {
                    this.error_iun_chemical_code = true;
                }
                if (this.iun_chemical_name == '') {
                    this.error_iun_chemical_name = true;
                }
            } else {
                if (this.selectedData == '') {
                    // โหลดเพิ่มแก้ไข 4/8
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 4/8 จบ

                    const userId = this.getUsername();
                    const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์

                    await this.axios
                        .post(`${this.$url_service}/initial/unnumber?user=${userId}`, {
                            body: {
                                topic: 'add-un',
                                userOrg,
                                code: this.iun_chemical_code,
                                name: this.iun_chemical_name,
                                manage: this.iun_chemical_manage
                            }
                        })
                        .then((response) => {
                            (this.check_duplicate = response.data.message),
                                // this.initialData();
                                this.searchChemicalInfo();

                            // โหลดเพิ่มแก้ไข 5/8
                            this.loadingCreate = false;
                            // โหลดเพิ่มแก้ไข 5/8 จบ

                            // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                            // console.log("this.check_duplicate ",this.check_duplicate)
                            if (this.check_duplicate == 'duplicate') {
                                this.$fire({
                                    type: 'error',
                                    title: 'เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ',
                                    text: 'มีข้อมูลนี้ในระบบแล้ว',
                                    timer: 3000,
                                    confirmButtonColor: '#d33'
                                });
                            } else {
                                this.$fire({
                                    title: 'เพิ่มข้อมูลสำเร็จ',
                                    text: 'ข้อมูลสารเคมี',
                                    type: 'success',
                                    timer: 3000,
                                    confirmButtonColor: '#28B463'
                                });
                            }
                        });
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    this.chemicalInfoModal = false;
                } else {
                    // โหลดเพิ่มแก้ไข 6/8 จบ
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 6/8 จบ

                    const userId = this.getUsername();

                    await this.axios
                        .post(`${this.$url_service}/initial/unnumber?user=${userId}`, {
                            body: {
                                topic: 'edit-un',
                                id: this.temp,
                                code: this.iun_chemical_code,
                                name: this.iun_chemical_name,
                                manage: this.iun_chemical_manage
                            }
                        })
                        .then(() =>
                            // this.initialData()
                            this.searchChemicalInfo()
                        );
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    this.loadingCreate = false;
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    // this.$toast.add({
                    //   severity: "success",
                    //   summary: "แก้ไขข้อมูลสำเร็จ",
                    //   detail: `ข้อมูลสารเคมี`,
                    //   life: 3000,
                    // });
                    this.$fire({
                        type: 'success',
                        title: 'แก้ไขข้อมูลสำเร็จ',
                        text: `ข้อมูลสารเคมี`,
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    this.chemicalInfoModal = false;
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            function toThaiDateFormat(dateString) {
                try {
                    // Split the date string by '/'
                    const [day, month, year] = dateString.split('/');

                    // Create a date object (months in JavaScript are 0-based, so subtract 1 from month)
                    const date = new Date(year, month - 1, day);

                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    // Format options
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    // Convert to Thai date
                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.header = this.$i18n.t('iun_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/unnumber`, {
                    body: {
                        topic: 'showone-un',
                        id: data
                    }
                })
                .then((response) => {
                    (this.selectedData = response.data.data),
                        (this.iun_chemical_code = response.data.data.un_code),
                        (this.iun_chemical_name = response.data.data.un_name),
                        (this.iun_chemical_manage = response.data.data.un_manage);

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);
                });
        },

        clearData() {
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('iun_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.chemicalInfoModal = false;
                this.selectedData = '';
                this.iun_chemical_code = '';
                this.iun_chemical_name = '';
                this.iun_chemical_manage = 'http://';
                this.error_iun_chemical_code = false;
                this.error_iun_chemical_name = false;

                this.date_create_form = '';
                this.date_update_form = '';

                //Add data
            } else {
                this.tempFor_displayConfirmationCloseModal = '';
                this.temp = null;
                this.displayConfirmation = false;
                this.iun_chemical_code = '';
                this.iun_chemical_name = '';
                this.iun_chemical_manage = 'http://';
                this.error_iun_chemical_code = false;
                this.error_iun_chemical_name = false;

                this.date_create_form = '';
                this.date_update_form = '';
            }
        },

        async clearSearchField() {
            this.chemical_name = '';
            this.chemical_code = '';

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.chemical_name = '';
                this.chemical_code = '';

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        alertDisplay(temp) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length == 1) {
                (this.PDF_minCellWidthVer = 80), (this.PDF_FontHeaderVer = 12), (this.PDF_FontBodyVer = 9), (this.PDF_BodySizeSelect = {});

                (this.PDF_minCellWidthHor = 70), (this.PDF_FontHeaderHor = 12), (this.PDF_FontBodyHor = 9), (this.PDF_BodySizeHorSelect = {});
            } else {
                (this.PDF_minCellWidthVer = 80),
                    (this.PDF_FontHeaderVer = 12),
                    (this.PDF_FontBodyVer = 9),
                    (this.PDF_BodySizeSelect = this.PDF_BodySize);

                (this.PDF_minCellWidthHor = 70),
                    (this.PDF_FontHeaderHor = 12),
                    (this.PDF_FontBodyHor = 9),
                    (this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor);
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_un_code = false;
                this.columns_un_name = false;
                this.columns_un_manage = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'un_code') {
                        this.columns_un_code = true;
                    } else if (!getData.includes('un_code')) {
                        this.columns_un_code = false;
                    }

                    if (element == 'un_name') {
                        this.columns_un_name = true;
                    } else if (!getData.includes('un_name')) {
                        this.columns_un_name = false;
                    }

                    if (element == 'un_manage') {
                        this.columns_un_manage = true;
                    } else if (!getData.includes('un_manage')) {
                        this.columns_un_manage = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.table_row {
    text-align: center;
}
@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
}
.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
